import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({

  // mode: 'history',
  // linkActiveClass: "active",
  base: '',
  // 路由跳转滚动条回到顶部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // setTimeout(() => {
      //   window.scrollTo(savedPosition.x, savedPosition.y)
      // }, 200)
      return savedPosition
    } else {
      //console.log(window.pageYOffset);
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [{
      path: '/',
      redirect: '/home',
    },
    {
      path: '/resetMobile',
      name: 'resetMobile',
      component: r => require.ensure([], () => r(require('@/pages/login/resetMobile')), 'resetMobile'),
      meta: {
        title: '变更新手机号',
      },
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: r => require.ensure([], () => r(require('@/pages/login/resetPassword')), 'resetPassword'),
      meta: {
        title: '重置密码',
      },
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: r => require.ensure([], () => r(require('@/pages/login/forgotPassword')), 'forgotPassword'),
      meta: {
        title: '忘记密码',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: r => require.ensure([], () => r(require('@/pages/login/login')), 'login'),
      meta: {
        title: '登录',
      },
    },
    {
      path: '/login/index',
      name: '',
      component: r => require.ensure([], () => r(require('@/pages/login/index')), 'index'),
      meta: {
        title: '微信登陆',
      },
    },
    {
      path: '/signup',
      name: 'signup',
      component: r => require.ensure([], () => r(require('@/pages/signUp/signup')), 'signup'),
      meta: {
        title: '注册',
      },
    },
    {
      path: '/companyInfo',
      name: 'companyInfo',
      component: r => require.ensure([], () => r(require('@/pages/signUp/companyInfo')), 'companyInfo'),
      meta: {
        title: '填写公司信息',
      },
    },
    {
      path: '/addAddress',
      name: 'addAddress',
      component: r => require.ensure([], () => r(require('@/pages/signUp/addAddress')), 'addAddress'),
      meta: {
        title: '添加收货地址',
      },
    },
    {
      path: '/submitImg',
      name: 'submitImg',
      component: r => require.ensure([], () => r(require('@/pages/signUp/submitImg')), 'submitImg'),
      meta: {
        title: '提交照片',
      },
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: r => require.ensure([], () => r(require('@/pages/order/orderDetail')), 'orderDetail'),
      meta: {
        title: '订单详情',
      },
    },
    {
      path: '/allOrder',
      name: 'allOrder',
      component: r => require.ensure([], () => r(require('@/pages/order/allOrder')), 'allOrder'),
      meta: {
        title: '全部订单',
      },
    },
    {
      path: '/home',
      name: 'home',
      component: r => require.ensure([], () => r(require('@/pages/home')), 'home'),
      meta: {
        title: '首页',
      },
    },
    {
      path: '/classify',
      name: 'classify',
      component: r => require.ensure([], () => r(require('@/pages/classify/classify')), 'classify'),
      meta: {
        title: '分类页',
      },
    },
    {
      path: '/classify/classlist',
      name: 'classlist',
      component: r => require.ensure([], () => r(require('@/pages/classify/classlist')), 'classlist'),
      meta: {
        title: '分类列表',
      },
    },
    {
      path: '/proDetail',
      name: 'proDetail',
      component: r => require.ensure([], () => r(require('@/pages/proDetail/proDetail')), 'proDetail'),
      meta: {
        title: '商品详情',
      },
    },
    {
      path: '/order',
      name: 'order',
      component: r => require.ensure([], () => r(require('@/pages/order/order')), 'order'),
      meta: {
        title: '进货单'
      }
    },
    {
      path: '/infoSetUp',
      name: 'infoSetUp',
      component: r => require.ensure([], () => r(require('@/pages/user/infoSetUp')), 'infoSetUp'),
      meta: {
        title: '信息设置'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: r => require.ensure([], () => r(require('@/pages/user/user')), 'user'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: r => require.ensure([], () => r(require('@/pages/user/userInfo')), 'userInfo'),
      meta: {
        title: '个人资料展示'
      }
    },
    {
      path: '/imgInfo',
      name: 'imgInfo',
      component: r => require.ensure([], () => r(require('@/pages/user/imgInfo')), 'imgInfo'),
      meta: {
        title: '证件资料'
      }
    },
    {
      path: '/confirmOrder',
      name: 'confirmOrder',
      component: r => require.ensure([], () => r(require('@/pages/order/confirmOrder')), 'confirmOrder'),
      meta: {
        title: '确认订单'
      }
    },
    {
      path: '/timeOut',
      name: 'timeOut',
      component: r => require.ensure([], () => r(require('@/pages/public/timeOut')), 'timeOut'),
      meta: {
        title: '请求超时'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: r => require.ensure([], () => r(require('@/pages/public/news')), 'news'),
      meta: {
        title: '公告消息'
      }
    },
    {
      path: '/404',
      name: '404',
      component: r => require.ensure([], () => r(require('@/pages/public/404')), '404'),
      meta: {
        title: '资源不存在'
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component: r => require.ensure([], () => r(require('@/pages/order/pay')), 'pay'),
      meta: {
        title: '支付页面'
      }
    },

    {
      path: '/helpPay',
      name: 'helpPay',
      component: r => require.ensure([], () => r(require('@/pages/order/helpPay')), 'helpPay'),
      meta: {
        title: '代支付页面'
      }
    },

    {
      path: '/wxpay',
      name: 'wxpay',
      component: r => require.ensure([], () => r(require('@/pages/order/wxpay')), 'wxpay'),
      meta: {
        title: '微信支付'
      }
    },
    {
      path: '/pay/complete',
      name: 'payComplete',
      component: r => require.ensure([], () => r(require('@/pages/order/payComplete')), 'payComplete'),
      meta: {
        title: '支付页面'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: r => require.ensure([], () => r(require('@/pages/search/search')), 'search'),
      meta: {
        title: '搜索页面'
      }
    },
    {
      path: '/searchList',
      name: 'searchList',
      component: r => require.ensure([], () => r(require('@/pages/search/searchList')), 'searchList'),
      meta: {
        title: '搜索列表'
      }
    },
    {
      path: '/buyHistory',
      name: 'buyHistory',
      component: r => require.ensure([], () => r(require('@/pages/history/buyHistory')), 'buyHistory'),
      meta: {
        title: '我的购买记录'
      }
    },
    {
      path: '/viewHistory',
      name: 'viewHistory',
      component: r => require.ensure([], () => r(require('@/pages/history/viewHistory')), 'viewHistory'),
      meta: {
        title: '我的浏览记录'
      }
    },
    {
      path: '/collectHistory',
      name: 'collectHistory',
      component: r => require.ensure([], () => r(require('@/pages/history/collectHistory')), 'collectHistory'),
      meta: {
        title: '我的收藏'
      }
    },
    {
      path: '/orderQuery',
      name: 'orderQuery',
      component: r => require.ensure([], () => r(require('@/pages/order/orderQuery')), 'orderQuery'),
      meta: {
        title: '快递详情'
      }
    },
    {
      path: '/financeIndex',
      name: 'financeIndex',
      component: r => require.ensure([], () => r(require('@/pages/finance/financeIndex')), 'financeIndex'),
      meta: {
        title: '小雨点金融'
      }
    },
    {
      path: '/quota',
      name: 'quota',
      component: r => require.ensure([], () => r(require('@/pages/finance/quota')), 'quota'),
      meta: {
        title: '小雨点额度'
      }
    },
    {
      path: '/toLoan',
      name: 'toLoan',
      component: r => require.ensure([], () => r(require('@/pages/finance/toLoan')), 'toLoan'),
      meta: {
        title: '我的借款'
      }
    },
    {
      path: '/toLoanDetail',
      name: 'toLoanDetail',
      component: r => require.ensure([], () => r(require('@/pages/finance/toLoanDetail')), 'toLoanDetail'),
      meta: {
        title: '借款详情'
      }
    },


    // 专区页面
    {
      path: '/activity',
      name: 'activity',
      component: r => require.ensure([], () => r(require('@/pages/activity/activity')), 'activity')
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js